
// This file configures the Supabase client using environment variables
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { getEnvironment } from '@/lib/environment';

// Get environment variables with fallbacks
const env = getEnvironment();
const SUPABASE_URL = env.SUPABASE_URL;
const SUPABASE_ANON_KEY = env.SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase environment variables');
}

// Create the Supabase client with explicit parameters
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  },
  global: {
    headers: {
      'Content-Type': 'application/json'
    }
  }
});
